// Essential to ensure Tailwind works correctly with our build
import '../css/main.css'

// CSS global imports
import '../css/global/global.css'

// CSS component imports
import '../css/components/article.css'
import '../css/components/newsletter-signup.css'
import '../css/components/shopify-challenge.css'
import '../css/components/swiper.css'


// JS Components
// Add JS component files here

// AlpineJS
import Alpine from 'alpinejs'
window.Alpine = Alpine

// Alpine Plugins
import collapse from '@alpinejs/collapse'
Alpine.plugin(collapse)

//Alpine Store
import './store'

// Alpine Directives
import { money, imageTransform } from './directives'
Alpine.directive('money', money)
Alpine.directive('image-transform', imageTransform)

// Alpine Components
import collection from './components/collection'
import customerAddresses from './components/customer-addresses'
import product from './components/product'
Alpine.data('collection', collection)
Alpine.data('customerAddresses', customerAddresses)
Alpine.data('product', product)

Alpine.start()
